import type { MapCenterPoint } from '../types';
import type { InteractiveMapItem } from '@skyscanner-internal/landing-pages-shared-types/src/types-shared/InteractiveMapProps';

/**
 * Get the center point of the map based on the items
 * @param {InteractiveMapItem} items - The items to calculate the center point from
 * @returns {MapCenterPoint | null} - The center point of the map or null if there are no items or more than one item
 */
const getCenter = (items: InteractiveMapItem[]): MapCenterPoint | null => {
  if (items.length !== 1) {
    return null;
  }

  const center = {
    latitude: items[0].mapMarker.lat,
    longitude: items[0].mapMarker.lng,
  };

  return center;
};

export default getCenter;
